import {createSlice} from "../../../__snowpack__/pkg/@reduxjs/toolkit.js";
import {DEFAULT_SKINNING} from "../../common/generic-react.styles.js";
export const CI_INITIAL_STATE = {
  name: "Leonardo",
  white_label: DEFAULT_SKINNING
};
export const clientInstanceStore = createSlice({
  name: "clientInstanceStore Store",
  initialState: CI_INITIAL_STATE,
  reducers: {
    setTheme: (state, action) => ({
      ...state,
      white_label: {
        ...CI_INITIAL_STATE.white_label,
        ...action.payload
      }
    }),
    resetTheme: (state) => ({
      ...state,
      white_label: CI_INITIAL_STATE.white_label
    }),
    setConfiguration: (state, action) => ({
      ...state,
      ...action.payload
    }),
    resetConfiguration: () => CI_INITIAL_STATE
  }
});
export default clientInstanceStore.reducer;
